import axiosInstance from "./AxiosInstance";

export const getPlan = async (params) => {
  try {
    const config = params ? { params } : {}; // only add if available
    const response = await axiosInstance.get("/api/get-diet-plan", config);
    return response.data;
  } catch (error) {
    console.error("Error fetching plan:", error);
    throw error;
  }
};

export const getPdfLink = async (params) => {
  try {
    const response = await axiosInstance.get("/api/get-diet-plan");
    return response.data;
  } catch (error) {
    console.error("Error getting link:", error);
    throw error;
  }
};

export const savePreferences = async (selectedTags) => {
  try {
    const response = await axiosInstance.post("api/update/form-fields", {
      preferences: {
        ...selectedTags,
        dailyCalorieAdjustment: (
          selectedTags["targetDailyCalories"] -
          selectedTags["maintenanceCalories"]
        ).toString(),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error saving preferences:", error);
    throw error;
  }
};

export const createDietPlan = async () => {
  try {
    const now = new Date();
    const start_time = `${now.getFullYear()}-${String(
      now.getMonth() + 1
    ).padStart(2, "0")}-${String(now.getDate()).padStart(2, "0")} ${String(
      now.getHours()
    ).padStart(2, "0")}:${String(now.getMinutes()).padStart(2, "0")}:${String(
      now.getSeconds()
    ).padStart(2, "0")}`;

    const response = await axiosInstance.post("api/create-diet-plan", {
      start_time,
    });

    return response.data;
  } catch (error) {
    console.error("Error creating diet plan:", error);
    throw error;
  }
};

export const getFields = async () => {
  try {
    const response = await axiosInstance.get("api/form-fields");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching form fields:",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const downloadDietPlan = () => {
  return axiosInstance.get(`/api/download/diet-plan`, {
    responseType: "blob",
  });
};

export const downloadShoppingList = () => {
  return axiosInstance.get(`/api/download/shopping-list`, {
    responseType: "blob",
  });
};

export const downloadDayShoppingList = (day) => {
  return axiosInstance.get(`/api/download/shopping-list`, {
    responseType: "blob",
    params: { day },
  });
};

export const downloadRecipe = (payload) => {
  return axiosInstance.get(`api/meal/pdf`, {
    responseType: "blob",
    params: payload,
  });
};

export const getPlanDates = async () => {
  try {
    const response = await axiosInstance.get("api/get-dietplan-dates");
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching dates",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const gerDietPlanRecipe = async ({ mealType, day, index ,date }) => {
  try {
    const response = await axiosInstance.get("api/get-meal", {
      params: {
        meal_type: mealType,
        day: day,
        index: index,
        date
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Error fetching meal",
      error.response ? error.response.data : error.message
    );
    throw error;
  }
};

export const saveSelectedDietPlan = async (selectedMeals) => {
  try {
    const response = await axiosInstance.post("api/selected-diet-plan", {
      selectedMeals,
    });
    return response.data;
  } catch (error) {
    console.error("Error saving selected diet plan:", error);
    throw error;
  }
};

export const rejectDietPlan = async () => {
  try {
    const response = await axiosInstance.post("api/reject-diet-plan");
    return response.data;
  } catch (error) {
    console.error("Error rejecting diet plan:", error);
    throw error;
  }
};

export const createOneMeal = async ({ mealName, day, mealType, calories }) => {
  try {
    const response = await axiosInstance.post("api/create-one-meal", {
      mealName,
      day,
      mealType,
      calories,
    });
    return response;
  } catch (error) {
    console.error("Error creating one meal:", error);
    throw error;
  }
};
